/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Intervals_Error_NetworkInputs */

const en_ui_intervals_error_network = /** @type {(inputs: Ui_Intervals_Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not reach intervals.icu.`)
};

const de_ui_intervals_error_network = /** @type {(inputs: Ui_Intervals_Error_NetworkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`intervals.icu war nicht erreichbar.`)
};

/**
* | output |
* | --- |
* | "Could not reach intervals.icu." |
*
* @param {Ui_Intervals_Error_NetworkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_intervals_error_network = /** @type {((inputs?: Ui_Intervals_Error_NetworkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Intervals_Error_NetworkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_intervals_error_network(inputs)
	return de_ui_intervals_error_network(inputs)
});